import { Card, Skeleton, Flex } from 'antd';

const ProductCardSkeleton = () => (
  <Card
    style={{
      borderRadius: 10,
      height: '100%',
    }}
    styles={{
      body: { padding: 12 },
    }}
  >
    <Flex gap={16}>
      <Skeleton.Avatar
        shape="square"
        size={128}
        style={{
          width: 128,
          height: 192,
          borderRadius: 8,
          minWidth: 128,
          maxWidth: 60,
          flexShrink: 0,
        }}
        active
      />
      <Flex vertical style={{ flex: 1 }}>
        <Skeleton.Input style={{ width: 80, height: 18, marginBottom: 8 }} active size="small" />
        <Skeleton.Input style={{ width: 120, height: 20, marginBottom: 2 }} active size="default" />
        <Skeleton.Input style={{ width: 60, height: 18, marginBottom: 8 }} active size="small" />
        <Skeleton.Button style={{ width: 110, height: 28 }} active size="small" />
      </Flex>
    </Flex>
  </Card>
);

export default ProductCardSkeleton;
